(() => {  
  window.addEventListener('abra:initialized', async () => {
    window.Abra.useSellingPlanPriceOnProductBlock = false;

    await new Promise(resolve => setTimeout(resolve, 1000));
    
    const subscriptionContainers = document.querySelectorAll('.purchase-option-wrap');

    subscriptionContainers.forEach((container) => {
      const isSubscription = container.getAttribute('@click').includes('subscription');
      const isSelected = container.getAttribute('class').includes('selected');

      if (isSubscription && isSelected) {
        window.Abra.useSellingPlanPriceOnProductBlock = true;
      }

      container.addEventListener('click', async (event) => {
        const isSubscription = event.currentTarget.getAttribute('@click').includes('subscription');
        const isSelected = event.currentTarget.getAttribute('class').includes('selected');

        if (isSubscription && isSelected) {
          window.Abra.useSellingPlanPriceOnProductBlock = true;
        }

        if (!isSubscription && isSelected) {
          window.Abra.useSellingPlanPriceOnProductBlock = false;
        }
      })
    });
  }); 
})();